export const socialsData = {
    github: 'https://github.com/ruhuRaj',
    // facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/randhir-kumar-raj-0528442b4/',
    // instagram: 'https://www.instagram.com/',
    // codepen: 'https://codepen.io/',
    // twitter: 'https://twitter.com/',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    // medium: 'https://medium.com/@',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    // youtube: 'https://youtube.com/'
}